import { render, staticRenderFns } from "./Selections.vue?vue&type=template&id=6ae933b1&scoped=true"
import script from "./Selections.vue?vue&type=script&lang=js"
export * from "./Selections.vue?vue&type=script&lang=js"
import style0 from "./Selections.vue?vue&type=style&index=0&id=6ae933b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae933b1",
  null
  
)

export default component.exports